import { render } from "./GalleryTemplate.vue?vue&type=template&id=5d03854e&scoped=true"
import script from "./GalleryTemplate.vue?vue&type=script&lang=js"
export * from "./GalleryTemplate.vue?vue&type=script&lang=js"

import "./GalleryTemplate.vue?vue&type=style&index=0&id=5d03854e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d03854e"]])

export default __exports__